export const NEW_COMMENT_MAX_HEIGHT = 128;
